const HOUR_MS = 60 * 60 * 1000
const DAY_MS = 24 * HOUR_MS

const pad = value => String(value).padStart(2, '0')

/**
 * 종료 timestamp를 기준으로 홈 카드에 보여줄 카운트다운을 계산한다.
 * `now`는 테스트와 background 복귀 시 실제 현재 시각을 주입할 수 있도록 받는다.
 */
export function getRegistrationCountdownDisplay(targetAt, now = Date.now()) {
  const currentMs = now == null ? Date.now() : new Date(now).getTime()
  const remainingMs = new Date(targetAt).getTime() - currentMs

  if (remainingMs <= 0) return { mode: 'ended', text: '예비수강신청 종료', remainingMs: 0 }

  // 정확히 1시간은 60:00으로 초 단위 모드에 포함하고, 다음 tick의 59:59부터
  // 사용자가 요청한 "1시간 이하" 긴박한 표시가 시작된다.
  if (remainingMs <= HOUR_MS) {
    const totalSeconds = Math.floor(remainingMs / 1000)
    const minutes = Math.floor(totalSeconds / 60)
    const seconds = totalSeconds % 60
    return { mode: 'seconds', text: `${pad(minutes)}:${pad(seconds)}`, remainingMs }
  }

  const totalMinutes = Math.floor(remainingMs / 60_000)
  if (remainingMs < DAY_MS) {
    return {
      mode: 'natural',
      text: `${Math.floor(totalMinutes / 60)}시간 ${totalMinutes % 60}분 남음`,
      remainingMs,
    }
  }

  return {
    mode: 'natural',
    text: `${Math.floor(totalMinutes / 1_440)}일 ${Math.floor((totalMinutes % 1_440) / 60)}시간 남음`,
    remainingMs,
  }
}
